import { render } from "./form3.vue?vue&type=template&id=be7135ca&scoped=true"
import script from "./form3.vue?vue&type=script&lang=js"
export * from "./form3.vue?vue&type=script&lang=js"

import "./form3.vue?vue&type=style&index=0&id=be7135ca&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be7135ca"]])

export default __exports__